import { apiRequest } from "../util/apiUtils";

export const getPageList = async (params) => {
  try {
    const res = await apiRequest("get", "admin/pages/list", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const changePagesStatus = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/pages/status-change", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
  }
};

export const deletePages = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/pages/delete", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
  }
};
export const editPages = async (params) => {
  try {
    const res = await apiRequest(
      "post",
      "admin/pages/edit",
      {
        body: { ...params },
      },
      "multipart/form-data"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const pagesDetails = async (params) => {
  try {
    const res = await apiRequest("get", `admin/pages/details/${params?.id}`, {});
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const pagesViewDetails = async (params) => {
  try {
    const res = await apiRequest("get", `admin/pages/details/${params}`, {});
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const addEditBanner = async (params) => {
  try {
    const res = await apiRequest(
      params.id ? "post" : "post",
      params.id ? "admin/banner/edit" : "admin/banner/add",
      {
        body: { ...params },
      },
      "multipart/form-data"
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const bannerDetails = async (params) => {
  try {
    const res = await apiRequest("get", `admin/banner/details/${params?.bannerId}`, {});
    return res?.data;
  } catch (err) {
    return err;
  }
};

export const deleteBanner = async (payload = {}) => {
  try {
    const res = await apiRequest("post", "admin/banner/delete", {
      body: payload,
    });
    return res;
  } catch (err) {
    return err;
    throw err;
  }
};
